import Layout from "@/components/Layout";
import Carousel from "@/components/Carousel";
import HubSpotForm from "@/components/HubSpotForm";

// Converted from index.php by scripts/convert-php-pages.mjs.
export default function Page() {
  return (
    <Layout route="/">
      <>
<style dangerouslySetInnerHTML={{ __html: "\r\n    .home-slider {\r\n  /* height: 92vh !important;  or whatever matches your slider */\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .common-btn a {\r\n        font-size: 13px;\r\n        padding: 8px;\r\n        border-radius: 5px;\r\n        margin-right: 0px !important;\r\n        margin-top: 100px;\r\n    }\r\n}\r\n" }} />
<Carousel className="home-slider" nav dots>
<div className="slider-item slider-item-img">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="slider-text">
<div className="common-btn">
<a href="#contact-sec">Get Appointment</a>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="slider-item slider-item-img-two">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="slider-text">
<div className="common-btn">
<a href="#contact-sec">Get Appointment</a>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="slider-item slider-item-img-three">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="slider-text">
<div className="common-btn">
<a href="#contact-sec">Get Appointment</a>
</div>
</div>
</div>
</div>
</div>
</div>
</Carousel>
<div className="counter-area">
<div className="container">
<div className="row counter-bg">
<div className="col-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-patient-bed"></i>
<h3>
<span className="odometer" data-count="85000">00</span>
</h3>
<p>OPD Patients</p>
</div>
</div>
<div className="col-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-people"></i>
<h3>
<span className="odometer" data-count="9300">00</span>
<span className="target">+</span>
</h3>
<p>Happy Patients</p>
</div>
</div>
<div className="col-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-doctor-alt"></i>
<h3>
<span className="odometer" data-count="200">00</span>
</h3>
<p>Seminar </p>
</div>
</div>
<div className="col-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-badge"></i>
<h3>
<span className="odometer" data-count="18">00</span>
</h3>
<p>Year Experience</p>
</div>
</div>
</div>
</div>
</div>
<style dangerouslySetInnerHTML={{ __html: "\r\n  .services-area h1{\r\n    font-size: 45px;\r\n  }\r\n\r\n  @media(max-width:768px){\r\n    .services-area h1{\r\n    font-size: 25px;\r\n  }\r\n  }\r\n" }} />
<section className="services-area pb-70" style={{ paddingTop: "38px" }}>
<div className="container">

<div className="row">

<h1> <strong> Chest Surgeon in India: Your Trusted Expert in Chest and Lung
          Surgery</strong></h1>
</div>
</div>
</section>

<div className="about-area pt-30 pb-70">
<div className="container">
<div className="row align-items-center">
<div className="col-lg-6">
<div className="about-item">
<div className="about-left">
<img data-src="/assets/img/drim.webp" width={730} height={500} style={{ height: "auto" }} className="lazy-load" alt="About" />
</div>
</div>
</div>
<div className="col-lg-6">
<div className="about-item about-right">
<img data-src="/assets/img/home-one/5.png" width={556} height={712} style={{ height: "auto" }} className="lazy-load" alt="About" />
<h2>Dr. Parveen Yadav<br /><span style={{ fontSize: "12px" }}>(Director, Thoracic Surgery and
              Surgical Oncology)</span></h2>
<p>Dr. Parveen Yadav is the Surgical Oncologist for Thoracic Surgeries. He completed a 2-year fellowship
            in Thoracic Surgery from the renowned Tata Memorial Hospital, Mumbai, which solidified his expertise in
            advanced thoracic procedures.

            Dr. Yadav also holds an MBBS and MS in General Surgery from the prestigious PT.B.D.Sharma Medical College,
            Rohtak. Additionally, he underwent 3 years of surgical oncology training at the Institute Rotary Cancer
            Hospital (IRCH) AIIMS, New Delhi, honing his skills in oncology care.

            His extensive training and expertise make him a trusted name in thoracic surgeries, providing world-class
            care to his patients. </p>
<ul>
<li>
<i className="icofont-check-circled"></i>
              He is Da Vinci certified trained Robotic Surgeon,
            </li>
<li>
<i className="icofont-check-circled"></i>
              MBBS, MS (General Surgery),
              FAIS, FAIGES
            </li>
<li>
<i className="icofont-check-circled"></i>
              Surgical Oncology (AIIMS)
            </li>
<li>
<i className="icofont-check-circled"></i>
              HBNI Fellowship in Thoracic Surgery (TATA Memorial Hospital, Mumbai)


            </li>

</ul>
<a href="/about">Know More</a>
</div>
</div>
</div>
</div>
</div>
<section className="services-area pb-70">
<div className="container">
<div className="row">

<div className="">

<hr />
<p className="mb-20">Cancer is one of the leading causes of death around the world. An average of 98 thousand to 1
          Lac people succumb to cancers of various types every year. </p>
<hr />
<p className="mb-20">While the disease is among the deadliest, it requires only the finest services. Proper
          treatment and diagnosis of the disease are required to bring this rate down by a considerable number. </p>
<hr />
<p className="mb-20">We at Chest Surgery India aim to provide just that. We have a team of the finest doctors and
          experts in the field of thoracic cancer. We provide oncology surgery and care in India. </p>
</div>
</div>
</div>
</section>
<section className="services-area pb-50">
<div className="container" style={{ marginBottom: "30px" }}>
<div className="row">
<div className="col-lg-6">
<div className="service-details-inner">
<h3>Who are we?</h3>
<hr />
<p className="mb-20">We are a team of thoracic surgeons in India. Our team is led by Dr. Parveen Yadav, who himself
            is a specialized Surgical Oncologist. We have catered to the needs of 2500+ patients so far. </p>
<hr />
<p>We specialize in providing treatments and diagnoses for thoracic cancer. With an experience of 18+ years,
            our surgeons have been a part of some of the major international conferences and national events. </p>
<hr />
<p>We specialize in the following areas of thoracic surgery in India. </p>
</div>
</div>
<div className="col-lg-6" style={{ paddingTop: "38px" }}>
<div className="">
<img data-src="/assets/img/espojial2.jpg" alt="Service" className="lazy-load" height={613} width={1176} style={{ width: "100%", height: "auto" }} />
</div>
</div>
</div>
</div>
</section>
<section className="services-area pb-50">
<div className="container">
<div className="section-title">
<h2>Our Treatments</h2>
</div>
<div className="row">
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".3s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/esc.png" className="lazy-load" height="71px" width="65px" alt="Esophageal Cancer" />
<h3>Esophageal Cancer</h3>
<p>Esophageal cancer is among the common ones, and they go highly unnoticed. There is a considerable
              disturbance, and it could even lead to total esophagus blockages.<br /><br /></p>
</div>
<div className="service-end">
<img data-src="/assets/img/esc.png" className="lazy-load" height="71px" width="65px" alt="Esophageal Cancer" />
<h3>Esophageal Cancer</h3>
<p>Esophageal cancer is among the common ones, and they go highly unnoticed. There is a considerable
              disturbance, and it could even lead to total esophagus blockages. <br /><br /></p>
<a href="/esophageal-cancer-treatment-gurgaon">Read More<span className="visually-hidden"> about esophageal cancer treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".5s">
<div className="service-item">
<div className="service-front">
<i className="icofont-lungs"></i>
<h3>Lung Cancer</h3>
<p>Lung Cancer is another fatal disease that is major in two types: Small Cell Carcinoma and Non-Small Cell
              Carcinoma. We undertake various screenings and investigations <br /><br /></p>
</div>
<div className="service-end">
<i className="icofont-lungs"></i>
<h3>Lung Cancer</h3>
<p>Lung Cancer is another fatal disease that is major in two types: Small Cell Carcinoma and Non-Small Cell
              Carcinoma. We undertake various screenings and investigations<br /><br /></p>
<a href="/lungs-cancer-treatment-gurgaon">Read More<span className="visually-hidden"> about lung cancer treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".7s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/trach.png" className="lazy-load" height="71px" width="65px" alt="Tracheal Disease" />
<h3>Tracheal Disease</h3>
<p>We also provide treatment and diagnoses for tracheal disease. In extreme cases, a part of the trachea is
              removed through surgery. Medications and diet are recommended <br /><br /></p>
</div>
<div className="service-end">
<img data-src="/assets/img/trach.png" height="71px" width="65px" className="lazy-load" alt="Tracheal Disease" />
<h3>Tracheal Disease</h3>
<p>We also provide treatment and diagnoses for tracheal disease. In extreme cases, a part of the trachea is
              removed through surgery. Medications and diet are recommended <br /><br /></p>
<a href="/tracheal-cancer-treatment-gurgaon">Read More<span className="visually-hidden"> about tracheal cancer treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".9s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/chestwall.png" className="lazy-load" height="71px" width="65px" alt="CHEST WALL" />
<h3>CHEST WALL</h3>
<p>Diseases and tumors in the chest wall are not common, but WakeMed thoracic surgeons offer <br /><br /></p>
</div>
<div className="service-end">
<img data-src="/assets/img/chestwall.png" height="71px" width="65px" className="lazy-load" alt="CHEST WALL" />
<h3>CHEST WALL</h3>
<p>Diseases and tumors in the chest wall are not common, but WakeMed thoracic surgeons offer<br /><br /> </p>
<a href="/chest-wall-tumor-surgery-gurgaon">Read More<span className="visually-hidden"> about chest wall tumor surgery</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".3s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/medi.png" className="lazy-load" height="71px" width="65px" alt="Mediastinal Mass" />
<h3>Mediastinal Mass</h3>
<p>The Mediastinal is a space between the breast bone and spinal cord. Cancer requires a wide range of
              diagnoses in order to locate the spread and cause of the tumor. <br /><br /> </p>
</div>
<div className="service-end">
<img data-src="/assets/img/medi.png" className="lazy-load" height="71px" width="65px" alt="Mediastinal Mass" />
<h3>Mediastinal Mass</h3>
<p>The Mediastinal is a space between the breast bone and spinal cord. Cancer requires a wide range of
              diagnoses in order to locate the spread and cause of the tumor. <br /><br /> </p>
<a href="/mediastinal-tumor-treatment-gurgaon">Read More<span className="visually-hidden"> about mediastinal tumor treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".5s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/empm.png" className="lazy-load" height="71px" width="65px" alt="EMPYEMA" />
<h3>EMPYEMA</h3>
<p>We are the thoracic surgeons in Delhi, and we aim to provide the appropriate treatment for Empyema. It is a
              type of gathering of tissues, particularly in the area <br /><br /></p>
</div>
<div className="service-end">
<img data-src="/assets/img/empm.png" className="lazy-load" height="71px" width="65px" alt="EMPYEMA" />
<h3>EMPYEMA</h3>
<p>We are the thoracic surgeons in Delhi, and we aim to provide the appropriate treatment for Empyema. It is a
              type of gathering of tissues, particularly in the area<br /><br /></p>
<a href="/empyema-treatment-gurgaon">Read More<span className="visually-hidden"> about empyema treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".7s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/fistula.png" className="lazy-load" height="71px" width="65px" alt="BRONCHOPLEURAL FISTULA" />
<h3>BRONCHOPLEURAL FISTULA</h3>
<p>These are large and abnormal passages that are developed in the lungs. They must be cured on time to
              avoid further damage. Our expert team undertakes the required </p>
</div>
<div className="service-end">
<img data-src="/assets/img/empm.png" className="lazy-load" height="71px" width="65px" alt="BRONCHOPLEURAL FISTULA" />
<h3>BRONCHOPLEURAL FISTULA</h3>
<p>These are large and abnormal passages that are developed in the lungs. They must be cured on time to
              avoid further damage. Our expert team undertakes the required </p>
<a href="/bronchopleural-fistula-treatment-gurgaon">Read More<span className="visually-hidden"> about bronchopleural fistula treatment</span></a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".9s">
<div className="service-item">
<div className="service-front">
<img data-src="/assets/img/bulliou.png" className="lazy-load" height="71px" width="65px" alt="BULLOUS DISEASE" />
<h3>BULLOUS DISEASE</h3>
<p>We are experts in treating Bullous disease, which is a rare skin condition. Proper medications and
              treatment are provided to kill the bacteria and clear the skin. <br /><br /></p>
</div>
<div className="service-end">
<img data-src="/assets/img/bulliou.png" className="lazy-load" height="71px" width="65px" alt="BULLOUS DISEASE" />
<h3>BULLOUS DISEASE</h3>
<p>We are experts in treating Bullous disease, which is a rare skin condition. Proper medications and
              treatment are provided to kill the bacteria and clear the skin. <br /><br /></p>
<a href="/bullous-disease">Read More<span className="visually-hidden"> about bullous disease treatment</span></a>
</div>
</div>
</div>
</div>
</div>
</section>
<section className="services-area pb-50">
<div className="container">
<div className="row">

<div className="">
<h3>Why consider us?</h3>
<hr />
<p className="mb-20">We are top surgical oncologists in India. With many happy patients, our services are top-notch.
          Complete care is provided until your cancer, and other diseases are treated from the roots. </p>
<hr />
<p className="mb-20">We provide 850 patients beds and all the required emergency services, right from ambulances to
          emergency wards, in order to cater to the needs of patients' needs. Our nursing staff of 750 strength is
          highly efficient and provides kind services to all. </p>
<hr />
<p className="mb-20">We make it a point to provide the right services and treatments depending on your diagnosis and
          physique. Diagnostic labs and other such facilities are available in the hospital itself. An independent
          diagnostic lab is beneficial as genuine results are produced. We make it a point to study the tumor cells in
          order to identify the basic cells from cancerous ones. </p>
<p>Our lead doctor, Dr. Parveen Yadav, is a well-recognized, Minimal Invasive Thoracic & Robotic Surgeries and
          Surgical Oncology doctor. He has been a major part of various international conferences and seminars. He also
          provides online videos spreading awareness about the care of various diseases. </p>
<p>Our team is patient-oriented, aiming to provide quality thoracic surgery services in Delhi.</p>
<p>Our clinic is based in Delhi’s Gurgaon. You can book an online appointment or even call us for details. Visit
          our website to get online consultations as per your requirements. Get in touch with us through WhatsApp and
          other social media platforms. </p>
<p>Next time you seek Onco surgeons in Delhi, be sure to <a href="#contact-sec">contact us.</a> </p>
</div>
</div>
</div>
</section>
<section style={{ boxShadow: "1px 4px 23px 0px" }}>
<div className="container">
<div className="row">
<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 col-lg-offset-2">
<div className="service_heading_wraper_3 text-center med_bottompadder70_3 wow fadeInDown" data-wow-delay="0.5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInDown" }}>
<h2 style={{ paddingTop: "20px", paddingBottom: "20px" }}>THE DIGITAL PRESENCE</h2>


</div>
</div>
<div className="col-lg-8 col-md-8 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-video" data-video-id="PGNxJHj2cLY" data-height="520">
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/PGNxJHj2cLY/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="391pHTWc_uE" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/391pHTWc_uE/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>
<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244">
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>


</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="PTwWMOweu98" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/PTwWMOweu98/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="EegO6lDSK8s" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img data-src="https://img.youtube.com/vi/EegO6lDSK8s/hqdefault.jpg" className="lazy-load" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
</div>
<div style={{ textAlign: "center", paddingBottom: "20px" }}>
<a href="/video"><button type="submit" className="btn feedback-btn" style={{ background: "#0046c0", color: "#fff", paddingBottom: "10p" }}>View More</button></a>
</div>
</div>
</section>
<section className="expertise-area pb-70 ">
<div className="container">
<div className="section-title" style={{ paddingTop: "30px" }}>
<h2>Our additional services</h2>
</div>
<div className="row align-items-center">
<div className="col-lg-6">
<div className="expertise-item">
<div className="row">
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".3s">
<a href="#contact-sec">
<div className="expertise-inner">
<i className="icofont-doctor-alt"></i>
<h3>Online consultations</h3>

</div>
</a>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".5s">
<a href="#contact-sec">
<div className="expertise-inner">
<i className="icofont-stretcher"></i>
<h3>Emergency contact</h3>

</div>
</a>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".3s">
<a href="#contact-sec">
<div className="expertise-inner">
<i className="icofont-network"></i>
<h3><span style={{ color: "#fff" }}>Book appointment</span></h3>

</div>
</a>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".5s">
<a href="#contact-sec">
<div className="expertise-inner">
<i className="icofont-ambulance-cross"></i>
<h3><span style={{ color: "#fff" }}>Book ambulance</span></h3>

</div>
</a>
</div>
</div>
</div>
</div>
<div className="col-lg-6">
<div className="expertise-item">
<div className="expertise-right">
<img data-src="/assets/img/hom2.jpg" width={626} height={552} style={{ height: "auto" }} className="lazy-load" alt="Expertise" />
</div>
</div>
</div>
</div>
</div>
</section>
<section className="drop-area pt-100" id="contact-sec">
<div className="container-fluid">
<div className="row">
<div className="col-lg-7 p-0">
<div className="drop-item drop-img">
<div className="drop-left">
<h2>Drop your message for any info or question.</h2>

<HubSpotForm />
</div>
</div>
</div>
<div className="col-lg-5 p-0">
<div className="speciality-item speciality-right speciality-right-two speciality-right-three">
<img data-src="/assets/img/home-two/8.jpg" width={845} height={851} style={{ height: "auto" }} className="lazy-load" alt="Contact" />
<div className="speciality-emergency">
<div className="speciality-icon">
<i className="icofont-ui-call"></i>
</div>
<h3>Call for Appointments</h3>
<a href="tel:+91 9540210956">
<p>+91 9540210956</p>
</a>
</div>
</div>
</div>
</div>
</div>
</section>
<div className="video-wrap">
<div className="container-fluid p-0">
<div className="tab-content" id="pills-tabContent">
<div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
<div className="video-area">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="video-item">
<a href="https://www.youtube.com/watch?v=nwkRMmAV1YY" className="popup-youtube" aria-label="Play patient education video">
<i className="icofont-ui-play"></i>
</a>
<div className="video-content">
<h3>youtube channel -</h3>
<p><strong>watch more video like</strong>
                      Patient education / Surgeries & Treatment / Patients stories
                      Life after surgery etc make this options as well</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
<div className="video-area">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="video-item">
<a href="https://www.youtube.com/watch?v=KVXCmyQcros" className="popup-youtube" aria-label="Play surgeries and treatment video">
<i className="icofont-ui-play"></i>
</a>
<div className="video-content">
<h3>About Our Pharmacy</h3>
<p>We provide 850 patients beds and all the required emergency services, right from ambulances to
                      emergency wards, in order to cater to the needs of patients' needs. Our nursing staff of 750
                      strength is highly efficient and provides kind services to all. </p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="tab-pane fade" id="pills-icu" role="tabpanel" aria-labelledby="pills-icu-tab">
<div className="video-area">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="video-item">
<a href="https://www.youtube.com/watch?v=einhtGs4J4c" className="popup-youtube" aria-label="Play patient story video">
<i className="icofont-ui-play"></i>
</a>
<div className="video-content">
<h3>CCU & ICU</h3>
<p>We make it a point to provide the right services and treatments depending on your diagnosis and
                      physique. Diagnostic labs and other such facilities are available in the hospital itself.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="tab-pane fade" id="pills-doctor" role="tabpanel" aria-labelledby="pills-doctor-tab">
<div className="video-area">
<div className="d-table">
<div className="d-table-cell">
<div className="container">
<div className="video-item">
<a href="https://www.youtube.com/watch?v=5WRncS7O70A" className="popup-youtube" aria-label="Play doctor video">
<i className="icofont-ui-play"></i>
</a>
<div className="video-content">
<h3>Our Doctors</h3>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                      maecenas accumsan lacus vel facilisis. </p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="container">
<ul className="video-nav nav nav-pills" id="pills-tab" role="tablist">
<li className="nav-item video-nav-item" role="presentation">
<a className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Patient education </a>
</li>
<li className="nav-item video-nav-item" role="presentation">
<a className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Surgeries &amp; Treatment</a>
</li>
<li className="nav-item video-nav-item" role="presentation">
<a className="nav-link" id="pills-icu-tab" data-bs-toggle="pill" href="#pills-icu" role="tab" aria-controls="pills-icu" aria-selected="false">Patients stories</a>
</li>



</ul>
</div>
</div>


<div className="container my-4">
<div className="row">
<div className="col-lg-12">
<h2 style={{ textAlign: "center", paddingBottom: "30px" }}>FAQs</h2>
<div className="accordion" id="accordionExample">
<div className="accordion" id="accordionExample">
<div className="row">
<div className="col-md-6">

<div className="accordion-item">
<h2 className="accordion-header" id="headingTwo">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                             How do I choose the surgical oncologist in India for thoracic procedures?
                          </button>
</h2>
<div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Look for specialized training, hands-on experience, and certifications. Dr. Parveen Yadav, our Chief Thoracic Surgeon, is a Da Vinci-certified robotic surgeon and holds fellowships from Tata Memorial Hospital and AIIMS, Delhi.
                          </div>
</div>
</div>
<div className="accordion-item">
<h2 className="accordion-header" id="headingSix">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                             What advanced treatments do you offer for lung cancer?
                          </button>
</h2>
<div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            We specialize in robot-assisted lobectomies, immunotherapy, and hyperthermic chemotherapy with PET-CT fusion imaging and molecular diagnostics.
                          </div>
</div>
</div>


<div className="accordion-item">
<h2 className="accordion-header" id="headingThree">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                             When should I consult a chest specialist in Gurgaon?
                          </button>
</h2>
<div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Persistent cough, chest pain, or breathing difficulties require immediate attention. Dr. Parveen Yadav offers advanced diagnostics and treatments for lung cancer and thoracic infections.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingFive">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                         Are your Delhi-NCR surgeons trained in robotic thoracic surgery?
                          </button>
</h2>
<div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Yes! Dr. Parveen Yadav is a Da Vinci-certified robotic surgeon offering minimally invasive lung and esophageal cancer procedures.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingFour">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                             What experience does Dr Parveen Yadav have in lung cancer surgery?
                          </button>
</h2>
<div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Dr. Yadav, trained at AIIMS and Tata Memorial Hospital, specializes in robotic-assisted surgeries, ensuring precision, faster recovery, and improved outcomes.
                          </div>
</div>
</div>
</div>
<div className="col-md-6">

<div className="accordion-item">
<h2 className="accordion-header" id="headingOne">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                             What facilities does your cancer hospital in Gurgaon provide?
                          </button>
</h2>
<div id="collapseOne" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Our Gurgaon-based centre is NCR’s leading cancer hospital. It is equipped with cutting-edge robotic technology (Da Vinci XI) and staffed by experts like Dr. Parveen Yadav, India’s surgical oncologist for thoracic surgeries.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingSeven">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                             Why choose Dr Yadav for thoracic surgery in Delhi-NCR?
                          </button>
</h2>
<div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            With AIIMS and Tata Memorial credentials, Dr. Yadav is renowned for precision in complex chest surgeries and compassionate care.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingEight">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                             Do you handle international patients?
                          </button>
</h2>
<div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Absolutely. From visa assistance to post-op rehab, we provide end-to-end support for international patients.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingNine">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                             What conditions do your thoracic surgeons treat?
                          </button>
</h2>
<div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            We treat lung/esophageal cancers, chest trauma, COPD, and rare malignancies using robotic surgery.
                          </div>
</div>
</div>

<div className="accordion-item">
<h2 className="accordion-header" id="headingTen">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                             How can I book a consultation with Dr Parveen Yadav?
                          </button>
</h2>
<div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#accordionExample">
<div className="accordion-body">
                            Visit or call to schedule an in-person consultation with Dr. Yadav. Emergency slots are available for urgent cases.
                          </div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>


      </>
    </Layout>
  );
}
